import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, type Observable } from 'rxjs';
import { Api } from 'src/app/core/api/Api';
import type { KWHConfig } from './kwh.model';

@Injectable({
  providedIn: 'root',
})
export class KwhService {
  constructor(private http: HttpClient) {}

  fetchKWH(): Observable<KWHConfig> {
    return this.http.get(Api.KWH).pipe(
      map((resp: KWHConfig) => {
        let clientUrl = resp.clientUrl;
        clientUrl = clientUrl.replace(/(.dev)|(.test)/, '');
        clientUrl = clientUrl.replace(/.kwh/, '.test.kwh');

        resp.clientUrlTesting = clientUrl;
        return resp;
      }),
    );
  }

  changeKWHDeadline(bankingDays: number) {
    return this.http.post(Api.ChangeKWHDeadline, { bankingDays });
  }

  changeableBankDetails(payload: any) {
    return this.http.post(Api.ChangeableBankDetails, payload);
  }

  toggleFeatureAutoApplyStandingOrders(activate: boolean) {
    return this.http.post(Api.ToggleAutoApplyStandingOrders, activate);
  }

  toggleFeatureGetPersonDataFromAtruvia(activate: boolean) {
    return this.http.post(Api.ToggleStammdatenweitergabe, activate);
  }

  letterHead(payload: any) {
    return this.http.post(Api.LetterHead, payload);
  }

  letterTemplatePreview(pdf: string) {
    return this.http.post(
      Api.LetterTemplatePreview,
      {
        pdf,
      },
      { responseType: 'text' },
    );
  }

  patchTemplateSenderAddress(kwhSettings: KWHConfig, result) {
    return {
      ...kwhSettings,
      templateSenderAddress: {
        faxNumber: result.faxNumber,
        phoneNumber: result.phoneNumber,
        department: result.department,
        city: {
          customValue: result.city,
          intbaValue: kwhSettings.templateSenderAddress.city.intbaValue,
        },
        postcode: {
          customValue: result.postcode,
          intbaValue: kwhSettings.templateSenderAddress.postcode.intbaValue,
        },
        displayName: {
          customValue: result.customValue,
          intbaValue: kwhSettings.templateSenderAddress.displayName.intbaValue,
        },
        address: {
          customValue: result.address,
          intbaValue: kwhSettings.templateSenderAddress.address.intbaValue,
        },
      },
    };
  }

  letterTemplate(base64: string) {
    const pdf = `data:application/pdf;base64,${base64}`;
    return this.http.post(Api.LetterTemplate, {
      pdf,
    });
  }

  getKWHLink(token: string, kwhUrl: string) {
    if (!kwhUrl.endsWith('/')) {
      kwhUrl = kwhUrl + '/';
    }
    return `${kwhUrl}login?accessToken=${token}`;
  }

  deactivateKWHService() {
    return this.http.post(Api.DeactivateKWHService, {});
  }

  activateKWHService() {
    return this.http.post(Api.ActivateKWHService, {});
  }
}
